/**
 * NewLogin reducer
 */

import { fromJS } from 'immutable';
import * as constants from './constants';
import * as appConstants from '../App/constants';

const { REQUEST, SUCCESS, FAILURE } = appConstants;

export const initialState = fromJS({
  loginV2Status: '',
  loginV2Error: null,
  validateOTPStatus: '',
  validateOTPError: null,
  resendOTPStatus: '',
  resendOTPError: null,
  forgotPasswordStatus: '',
  forgotPasswordError: null,
  setPasswordStatus: '',
  setPasswordError: null,
  showPasswordField: false,
  checkingSsoDomain: false,
  email: '',
  otpSessionGuard: constants.OTP_SESSION_GUARD.PENDING,
});

const newLoginReducer = (state = initialState, action = {}) => {
  switch (action?.type) {
    case constants.LOGIN_V2_REQUEST:
      return state
        .set('loginV2Status', REQUEST)
        .set('loginV2Error', null);

    case constants.LOGIN_V2_SUCCESS:
      return state
        .set('loginV2Status', SUCCESS)
        .set('loginV2Error', null);

    case constants.LOGIN_V2_FAILURE:
      return state
        .set('loginV2Status', FAILURE)
        .set('loginV2Error', action.error);

    case constants.VALIDATE_OTP_REQUEST:
      return state
        .set('validateOTPStatus', REQUEST)
        .set('validateOTPError', null);

    case constants.VALIDATE_OTP_SUCCESS:
      return state
        .set('validateOTPStatus', SUCCESS)
        .set('validateOTPError', null);

    case constants.VALIDATE_OTP_FAILURE:
      return state
        .set('validateOTPStatus', FAILURE)
        .set('validateOTPError', action.error);

    case constants.RESEND_OTP_REQUEST:
      return state
        .set('resendOTPStatus', REQUEST)
        .set('resendOTPError', null);

    case constants.RESEND_OTP_SUCCESS:
      return state
        .set('resendOTPStatus', SUCCESS)
        .set('resendOTPError', null);

    case constants.RESEND_OTP_FAILURE:
      return state
        .set('resendOTPStatus', FAILURE)
        .set('resendOTPError', action.error);

    case constants.FORGOT_PASSWORD_REQUEST:
      return state
        .set('forgotPasswordStatus', REQUEST)
        .set('forgotPasswordError', null)
        .set('isLoading', true);

    case constants.FORGOT_PASSWORD_SUCCESS:
      return state
        .set('forgotPasswordStatus', SUCCESS)
        .set('forgotPasswordError', null)
        .set('isLoading', false);

    case constants.FORGOT_PASSWORD_FAILURE:
      return state
        .set('forgotPasswordStatus', FAILURE)
        .set('forgotPasswordError', action.error)
        .set('isLoading', false);

    case constants.SET_PASSWORD_REQUEST:
      return state
        .set('setPasswordStatus', REQUEST)
        .set('setPasswordError', null)
        .set('isLoading', true);

    case constants.SET_PASSWORD_SUCCESS:
      return state
        .set('setPasswordStatus', SUCCESS)
        .set('setPasswordError', null)
        .set('isLoading', false);

    case constants.SET_PASSWORD_FAILURE:
      return state
        .set('setPasswordStatus', FAILURE)
        .set('setPasswordError', action.error)
        .set('isLoading', false);

    case constants.CHECK_SSO_DOMAIN_REQUEST:
      return state
        .set('checkingSsoDomain', true)
        .set('loginV2Error', null)
        .set('email', action.email);

    case constants.CHECK_SSO_DOMAIN_SUCCESS:
      return state
        .set('checkingSsoDomain', false)
        .set('loginV2Error', null);

    case constants.CHECK_SSO_DOMAIN_FAILURE:
      return state
        .set('checkingSsoDomain', false)
        .set('loginV2Error', action.error);

    case constants.SHOW_PASSWORD_FIELD:
      return state
        .set('checkingSsoDomain', false)
        .set('showPasswordField', true)
        .set('loginV2Error', null);

    case constants.RESET_PASSWORD_FIELD:
      return state
        .set('showPasswordField', false)
        .set('checkingSsoDomain', false)
        .set('loginV2Error', null);

    case constants.OTP_SESSION_CHECK_REQUEST:
      return state.set('otpSessionGuard', constants.OTP_SESSION_GUARD.PENDING);

    case constants.OTP_SESSION_CHECK_SUCCESS:
      return state.set('otpSessionGuard', constants.OTP_SESSION_GUARD.VALID);

    case constants.OTP_SESSION_CHECK_FAILURE:
      return state.set('otpSessionGuard', constants.OTP_SESSION_GUARD.INVALID);

    case constants.CLEAR_ERROR:
      return state
        .set('loginV2Error', null)
        .set('validateOTPError', null)
        .set('resendOTPError', null)
        .set('forgotPasswordError', null)
        .set('setPasswordError', null)
        .set('forgotPasswordStatus', '')
        .set('setPasswordStatus', '');

    default:
      return state;
  }
};

export default newLoginReducer;
